var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgL3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5211_192275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4353 5.39371L17.7618 4.72021C17.5471 4.50549 17.2863 4.34247 16.9992 4.24354L10.5633 2.0258C9.84023 1.77663 9.03834 1.96166 8.49753 2.50247L3.56792 7.43208C3.03107 7.96893 2.84449 8.76346 3.08625 9.48316L5.26514 15.9695C5.36351 16.2623 5.52838 16.5284 5.74682 16.7468L18.3848 29.3848C19.1658 30.1658 20.4322 30.1658 21.2132 29.3848L30.4056 20.1924C31.1866 19.4113 31.1866 18.145 30.4056 17.364L30.3816 17.34",
    stroke: "#00619E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5355,
    cy: 9,
    r: 2.5,
    transform: "rotate(-45 10.5355 9)",
    fill: "white",
    stroke: "#00619E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9391 11.0304L23.9696 18L17 11.0304H20.76V4H27.0569V11.0304H30.9391Z",
    stroke: "#00AED9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5211_192275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgL3);
export default __webpack_public_path__ + "static/media/l3.57ffe672d70005eefa33670a2df86e73.svg";
export { ForwardRef as ReactComponent };